import { render, staticRenderFns } from "./guangzhouCourseList.vue?vue&type=template&id=66f48d79"
import script from "./guangzhouCourseList.vue?vue&type=script&lang=js"
export * from "./guangzhouCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports